export const environment = {
  production: false,
  local: false,
  // 阿里云配置
  aliyun: {
    accountid: "5812349734908263",
    accessKeyID: "LTAI5tFErLpby3kVEQZA8Z84",
    accessKeySecret: "N141i8npOBR378dhha1BuTYgTpddgh",
    securityToken: null,
    region: "ap-northeast-1",
    secure: true,
    internal: false,
    serviceName: "IntaHealth-Service-dev",
    functionName: "IntaHealth-Functions",
  },
  auth0: {
    domain: "dev-gzf7mz68.us.auth0.com",
    clientId: "evfJ4w7Y2WQfA1VX2ug5qQcL3BTQlPvY",
    audience: "http://localhost:7001/",
    apiUri: "http://localhost:7001/",
    appUri: "http://localhost:4200",
    errorPath: "/error",
  },
  isAppUserCms: true,
  cmsUserConnection: "Username-Password-Authentication",
  appUserConnections: {
    usernamePassword: "Username-Password-Client",
    google: "google-oauth2",
    line: "line",
    apple: 'apple'
  },
};
